export function getSiteInfo() {
  const COMMON_CONFIG = {
    SALES_NUMBER_DISPLAY: "(800) 461-8535",
    SALES_NUMBER_CALL: "+18004618535",
  };

  const INTEGRATION_REQUEST_ENDPOINT = "/services/integrationRequest";

  const LIVE_CONFIG = {
    ...COMMON_CONFIG,
    IS_LIVE: true,
    LOGIN_URL: "https://my.answerforce.app/",
    LEAD_REGISTRATION_API:
      "https://signup.answerforce.com/services/leadRegistration",
    INTEGRATION_REQUEST_API: `https://signup.answerforce.com${INTEGRATION_REQUEST_ENDPOINT}`,
    DIRECT_SIGNUP_URL: "https://join.answerforce.com/signup?directSignup=true",
  };

  const STAGING_CONFIG = {
    ...COMMON_CONFIG,
    IS_LIVE: false,
    LOGIN_URL: "https://my.staging.answerforce.app/",
    LEAD_REGISTRATION_API:
      "https://signup.staging.answerforce.com/services/leadRegistration",
    DIRECT_SIGNUP_URL:
      "https://join.staging.answerforce.com/signup?directSignup=true",
    INTEGRATION_REQUEST_API: `https://signup.staging.answerforce.com${INTEGRATION_REQUEST_ENDPOINT}`,
  };

  return process.env.IS_LIVE ? LIVE_CONFIG : STAGING_CONFIG;
}

export function setCookie(key, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + 24 * days * 60 * 60 * 1e3);
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${key}=${value}${expires}; domain=${window.location.hostname.replace(
    "www",
    ""
  )};path=/;secure`;
}

export function getCookieValue(cookieName) {
  try {
    const cookiesArray = document.cookie.split(";");
    for (let i = 0; i < cookiesArray.length; i += 1) {
      let x = cookiesArray[i].substr(0, cookiesArray[i].indexOf("="));
      const y = cookiesArray[i].substr(cookiesArray[i].indexOf("=") + 1);
      x = x.replace(/^\s+|\s+$/g, "");
      if (x === cookieName) {
        return unescape(y);
      }
    }
    return "";
  } catch (e) {
    console.error(e); //eslint-disable-line
    return "";
  }
}

export function isRegisteredUser() {
  return getCookieValue("isregistered") === "true";
}

export function getPlansCTAUrl(isRegistered) {
  return isRegistered ? "/plans" : "/register";
}

export function highlightInvalidFields(integrationInfo = {}) {
  Object.values(integrationInfo).forEach((value) => {
    if (!value.valid && value.selector) {
      document.querySelector(value.selector).classList.add("error");
      if (value.selector === "#description-field") {
        document
          .querySelector("#description-field")
          .parentElement.classList.add("error");
      }
    } else if (value.valid && value.selector) {
      document.querySelector(value.selector).classList.remove("error");
      if (value.selector === "#description-field") {
        document
          .querySelector("#description-field")
          .parentElement.classList.remove("error");
      }
    }
  });
}

export function onFocus(event) {
  const elementFocused = event.target;
  elementFocused.classList.remove("error");
  if (elementFocused.id === "description-field") {
    elementFocused.parentElement.classList.remove("error");
  }
}

export function isLeadInfoValid(leadInfo) {
  if (leadInfo && Object.keys(leadInfo).length) {
    return (
      Object.values(leadInfo).filter((value) => value.valid).length ===
      Object.keys(leadInfo).length
    );
  }
  return false;
}

export const getSignupURL = (router) => {
  let cookieSignupURL =
    getCookieValue("common_cookie") || getSiteInfo().DIRECT_SIGNUP_URL;

  if (
    router.pathname.includes("/franchise") &&
    cookieSignupURL &&
    !cookieSignupURL.includes("category=FranchisePlans")
  ) {
    cookieSignupURL +=
      (cookieSignupURL.includes("?") ? "&" : "?") + "category=FranchisePlans";
  }
  if (
    router.pathname === "/plans" &&
    cookieSignupURL &&
    cookieSignupURL.includes("category=FranchisePlans")
  ) {
    cookieSignupURL = cookieSignupURL.replace(
      "category=FranchisePlans",
      "category=LiveAnswer"
    );
  }

  return cookieSignupURL;
};

export const getDiscountConfig = (pathname) => {
  const discountCodeMapping = {
    "/plans-ria-affinity": {
      code: process.env.IS_LIVE ? "11800" : "14100",
      planIds: [
        process.env.IS_LIVE ? "5328" : "5311",
        process.env.IS_LIVE ? "5329" : "5312",
        process.env.IS_LIVE ? "5360" : "5336",
        process.env.IS_LIVE ? "5361" : "5337",
        process.env.IS_LIVE ? "5362" : "5338",
        process.env.IS_LIVE ? "5363" : "5339",
      ],
      discountPercentage: 6,
    },
  };

  return discountCodeMapping[pathname] || null;
};

export const constructSignupURL = (baseURL, planId, pathname) => {
  const discountConfig = getDiscountConfig(pathname);
  if (!discountConfig) return `${baseURL}&planid=${planId}`;

  const isDiscountPlan = discountConfig.planIds.includes(planId);
  return `${baseURL}&planid=${planId}${
    isDiscountPlan
      ? `&discountCode=${discountConfig.code}&customPlan=true`
      : "&customPlan=true"
  }`;
};

export const calculateDiscountedPrice = (price, planId, pathname) => {
  const discountConfig = getDiscountConfig(pathname);
  const discountPercentage = discountConfig?.discountPercentage || 0;
  const isDiscountPlan = discountConfig?.planIds.includes(planId);

  return isDiscountPlan ? price - price * (discountPercentage / 100) : price;
};

const partnerPages = ["/lp/ria-affinity-program"];
export const isPartnerPage = (pathName) =>
  partnerPages.some((page) => pathName.startsWith(page));

export function getUtmSource(partnerName) {
  if (partnerName == "/lp/ria-affinity-program") {
    return "RIA-Affinity-Program";
  }
  return `${partnerName}`;
}
